// src/components/PasswordStrength.tsx
// Password strength indicator bar.

import { cn } from '@core/ui';

interface PasswordStrengthProps {
  score: number; // 0-4
  label?: string;
  className?: string;
}

const segmentColors = [
  'bg-destructive',
  'bg-orange-500',
  'bg-yellow-500',
  'bg-green-500',
];

export function PasswordStrength({ score, label, className }: PasswordStrengthProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <div className="flex gap-1">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'h-1.5 flex-1 rounded-full transition-colors',
              i < score ? segmentColors[Math.min(score - 1, 3)] : 'bg-muted',
            )}
          />
        ))}
      </div>
      {label && <p className="text-xs text-muted-foreground">{label}</p>}
    </div>
  );
}
